import { useTheme } from '@mui/material';
import { SVGProps } from 'react';

export const TopupRoundIcon = ({
  stroke,
  ...props
}: SVGProps<SVGSVGElement>) => {
  const theme = useTheme();
  const strokeColor = stroke || theme.palette.common.black;
  return (
    <svg
      width={36}
      height={36}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={36} height={36} fill={theme.palette.grey[100]} rx={18} />
      <path
        d="M24.6458 17.5417V14.1042C24.6458 13.5979 24.2354 13.1875 23.7292 13.1875H11.3542C10.8479 13.1875 10.4375 13.5979 10.4375 14.1042V21.8958C10.4375 22.4021 10.8479 22.8125 11.3542 22.8125H17.5417"
        stroke={strokeColor}
        strokeWidth={1.25}
        strokeLinecap="round"
      />
      <circle
        cx="17.5417"
        cy="18.0001"
        r="1.60417"
        stroke={strokeColor}
        strokeWidth={1.25}
      />
      <path
        d="M23.37 19.4922V25.7322M20.25 22.6122H26.49"
        stroke={strokeColor}
        strokeWidth={1.25}
        strokeLinecap="round"
      />
    </svg>
  );
};
